import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateProjectModelFromProjectRequestFailure() {
      return getState().isFailure;
    },
    isCreateProjectModelFromProjectRequestPending() {
      return getState().isPending;
    },
    isCreateProjectModelFromProjectRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
